<template>
    <div class="wrap">
        <div class="container">
            <div class="help_title">
                <p>{{article.title}}</p>
                <p></p>
            </div>
            <van-divider :style="{ borderColor: '#eee', margin: '0' }"></van-divider>
            <div class="help" v-html="article.content">
				
				
			</div>
        </div>
        <v-foot></v-foot>
    </div>
</template>

<script>
	var _this;
    // @ is an alias to /src
    export default {
        components: {},
		created() {
			_this = this;
			this.aid = this.$route.query.id;
			this.getData(this.aid);
		},
        watch: {
            $route: {
                handler() {
                    this.aid = this.$route.query.id;
                    this.getData(this.aid);
                    //深度监听，同时也可监听到param参数变化
                },
                deep: true,
            }
        },
		
        data() {
			return {
				"aid":0,
				"article":[],			
			}
        },
        methods: {
			getData(id){
				this.POST("api/article/index",{"id":id},function(d){
					// window.console.log(d);
					if(d.code == 0){
						_this.article = d.data;
					}else{
						_this.$toast(d.msg);
					}
				});
			},
        },
    }
</script>